import { reaction } from "mobx";
import { useEffect } from "react";

export function useReaction<T>(callback: (value: T, previousValue: T) => void, dependency: () => T, initial = true) {
    useEffect(() => {
        if (initial) {
            callback(dependency(), dependency());
        }
        return reaction(dependency, callback);
    }, []); // eslint-disable-line
}

